import React from 'react';

const SliderRightIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48px"
      height="48px"
      viewBox="0 0 48 48"
      version="1.1"
    >
      <g
        id="icon-slider-right-caret--48x48"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <polyline
          id="Path"
          stroke="#F2F5F8"
          transform="translate(21.000000, 24.000000) rotate(-45.000000) translate(-21.000000, -24.000000) "
          points="30.9598786 14 31 34 11 33.9598786"
        />
      </g>
    </svg>
  );
};

export default SliderRightIcon;
